var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 5.5L2 4.5L3 4.25L2 4L1.75 3L1.5 4L0.5 4.25L1.5 4.5L1.75 5.5Z",
    fill: "#265EDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.5L7.97 3.465L9 3L7.97 2.535L7.5 1.5L7.04 2.535L6 3L7.04 3.465L7.5 4.5Z",
    fill: "#265EDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4C9.775 4 9.37 4.72 9.535 5.255L7.76 7.035C7.61 6.99 7.39 6.99 7.24 7.035L5.965 5.76C6.135 5.225 5.73 4.5 5 4.5C4.275 4.5 3.865 5.22 4.035 5.76L1.755 8.035C1.22 7.87 0.5 8.275 0.5 9C0.5 9.55 0.95 10 1.5 10C2.225 10 2.63 9.28 2.465 8.745L4.74 6.465C4.89 6.51 5.11 6.51 5.26 6.465L6.535 7.74C6.365 8.275 6.77 9 7.5 9C8.225 9 8.635 8.28 8.465 7.74L10.245 5.965C10.78 6.13 11.5 5.725 11.5 5C11.5 4.45 11.05 4 10.5 4Z",
    fill: "#265EDB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.0b3d44f4ce8058381a5b984ea2e8dee4.svg";
export { ForwardRef as ReactComponent };